<div class="error-container" role="alert" aria-live="assertive">{{ error }}</div>
